import { validate_endpoint_url } from "@/utils/validated_url";

export function ensure_trailing_slash(url) {
    if (!url) {
        return "";
    }

    return url.endsWith("/") ? url : `${url}/`;
}

export function normalize_properties_response(payload) {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (Array.isArray(payload?.results)) {
        return payload.results;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    return [];
}

export async function ajax_json_request(request_url, options = {}) {
    const validated_url = validate_endpoint_url(request_url, process.env.VUE_APP_VIEW_USER_URL);
    const response = await fetch(validated_url, { ...options, redirect: "error" });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data?.message || data?.detail || data?.error || "Request failed.");
    }

    return data;
}
